<template>
  <div>
    <select-shop
      :loadingButton="loadingButton"
      v-on:getData="getStockOutReportByItem"
    ></select-shop>
    <div v-if="isPermission">
      <CCard class="shadow-sm">
        <CCardBody>
          <div class="row">
            <h2 id="stockOutTitle" class="col-md-10  col-sm-9 col-8 font-weight-normal">
              {{ $t('stockOutbyTypeReport') }}
            </h2>
            <div
              v-if="isExport"
              class="col-md-2 col-sm-3 col-4 text-right text-success"
            >
              <CButton id="stockOutExportButton" v-on:click="exportStockOutReport()" block color="info">
                <img src="/img/file-excel.png" alt="Excel Icon" style="width: 16px; height: 16px; margin-right: 8px; vertical-align: middle; position: relative; top: -2px;" />{{ $t('export') }}
              </CButton>
            </div>
          </div>
          <show-date></show-date>
          <CCard class="sort">
            <CCardBody style="padding: 10px; padding-right: 16px;">
              <CRow class="btn-group btn-group-toggle row">
                <span class="p-1 font-weight-normal col-2 col-md-1 col-sm-1 col-xl-1 text-right" style="margin-top: 8px;">{{ $t('StockOutType') }}</span>
                <CCol class="col-10 p-1 col-md-3 col-sm-5 col-xl-2">
                  <select id="stockOutFilterType" v-model="selectedType" class="custom-select">
                    <option :value="''">{{ $t('all') }}</option>
                    <option v-for="item in enabledTypeOptions" :key="item.id" :value="item.id">
                      {{ item.nameTranslation[$i18n.locale.toUpperCase()] || item.name }}
                    </option>
                  </select>
                </CCol>
                <CCol class="p-1 pr-2 col-12 col-md-5 col-sm-6 col-xl-7">
                  <input
                    id="stockOutSearchkeyword"
                    v-model="keyword"
                    type="text"
                    class="form-control"
                    :placeholder="$t('keyword')"
                  />
                </CCol>
                <CCol class="col-12 col-md-3 col-sm-12 p-1 col-xl-2 text-right">
                  <CButton id="stockOutSearchButton" color="success" block @click="getStockOutReportByItem()">
                     {{ $t('search') }}
                  </CButton>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
          <CRow>
            <CCol sm="12" lg="12">
              <CDataTable
                id="stockOutDatatable"
                style="white-space: nowrap;"
                :items="groupByItems"
                :fields="groupByItemFields"
                :loading="loading"
                hover
                border
              >
                <template #unit="{item}">
                  <td style="vertical-align: middle;" class="text-dark">
                    {{ item.SKURatio }} / {{ item.unit }}
                  </td>
                </template>
                <template #typeName="{ item }">
                  <td style="vertical-align: middle;" class="text-dark">
                    {{ getCategoryName(item.category) }}
                  </td>
                </template>
                <template #no-items-view>
                  <div class="text-center my-5">
                    <h4 style="color: #ced2d8;">
                      {{ $t('noItem') }}
                    </h4>
                  </div>
                </template>
                <template #discount="{ item }">
                  <td v-if="item.discount < 0.00" class="text-right font-weight-normal text-danger">{{ item.discount }}</td>
                  <td v-else class="text-right font-weight-normal text-dark">{{ item.discount }}</td>
                </template>
              </CDataTable>
            </CCol>
          </CRow>
          <pagination :meta_data="meta_data" v-on:next="getStockOutReportByItem">
          </pagination>
        </CCardBody>
      </CCard>
    </div>
    <div v-else>
      <access-data></access-data>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import axios from '@/services/service'
import local from '@/services/local'
import report from '@/services/report'
import util from '@/util/util'
import Pagination from '@/containers/Pagination'
import permis from '@/util/permission'
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      data: [],
      dataByItem: [],
      loadingButton: true,
      meta_data: {
        last_page: null,
        current_page: 1,
        items: 0,
        limit: 50,
        itemCount: null,
      },
      keyword: '',
      selectedType: '',
      typeOptions: [],
    }
  },
  computed: {
    ...mapGetters(['shops', 'date', 'users']),
    enabledTypeOptions() {
      return this.typeOptions.filter(item => item.enabled)
    },
    shopObjectId: {
      get() {
        return this.$store.getters.shopObjectId
      },
      set(newValue) {
        return this.$store.dispatch('setShop', newValue)
      },
    },
    isPermission() {
      // return true
      return permis.findPermissionRead('report', this.$route.path)
    },
    isExport() {
      // return true
      return permis.findPermissionExport('report', this.$route.path)
    },
    startDate() {
      return moment(String(this.date.start)).format('DD MMMM YYYY')
    },
    endDate() {
      return moment(String(this.date.end)).format('DD MMMM YYYY')
    },
    items() {
      let data = this.data
      let detail = []
      for (let i = 0; i < data.length; i++) {
        let PLUCode = ''
        let unit = ''
        let status = ''
        let classes = ''
        let SKURatio = '-'
        if (data[i].items.productPLU.PLUCode !== undefined) {
          PLUCode = data[i].items.productPLU.PLUCode
        }

        if (data[i].items.productPLU.unit.name !== undefined) {
          unit = data[i].items.productPLU.unit.name
        }
        if (data[i].items.deleted_at != null) {
          classes = 'text-danger'
          status = 'ยกเลิก'
        } else {
          classes = 'text-black'
          status = 'ใช้งาน'
        }
        if (data[i].items.productPLU.SKURatio === undefined) {
          SKURatio = '-'
        } else {
          SKURatio = data[i].items.productPLU.SKURatio
        }
        let discount = data[i].items.discount
        if (discount > 0) {
          discount *= -1
        }
        detail.push({
          id: i + 1,
          PLUCode: PLUCode,
          name: data[i].items.productPLU.name,
          documentNo: data[i].stockNo,
          billNo: data[i].billNo || '',
          date: moment(String(data[i].created_at)).format(
            'DD MMMM YYYY HH:mm:ss'
          ),
          unit: unit,
          cost: util.convertCurrency(data[i].items.cost),
          quantity: data[i].items.quantity,
          discount: util.convertCurrency(discount),
          total: util.convertCurrency(data[i].items.total),
          _classes: classes,
          status: status,
          SKURatio: SKURatio,
          // netAmount: util.convertCurrency(data[i].totalAmount),
        })
      }
      return detail
    },
    groupByItemFields() {
      return [
        // { key: 'index', label: '#', _classes: 'text-center text-dark font-weight-normal', _style: 'width:5%',},
        { key: 'date', label: this.$i18n.t('date'), _classes: 'text-center text-dark font-weight-normal', _style: 'width:5%',},
        { key: 'PLUCode', label: this.$i18n.t('pluCode'), _classes: 'text-dark font-weight-normal' },
        { key: 'name', label: this.$i18n.t('productName'), _classes: 'text-dark font-weight-normal' },
        { key: 'typeName', label: this.$i18n.t('StockOutType'), _classes: 'text-dark font-weight-normal' },
        // { key: 'unit', label: this.$i18n.t('unit'), _classes: 'text-dark font-weight-normal' },
        {
          key: 'totalQuantity',
          label: this.$i18n.t('stockOutQty'),
          _classes: 'text-right font-weight-normal text-dark',
        },
        // {
        //   key: 'totalCost',
        //   label: this.$i18n.t('priceUnit'),
        //   _classes: 'text-right font-weight-normal text-dark',
        // },
        // {
        //   key: 'totalAmount',
        //   label: this.$i18n.t('totalAmount'),
        //   _classes: 'text-right font-weight-normal text-dark',
        // },
      ]
    },
    groupByItems() {
      const data = this.dataByItem || []
      let detail = []
      for (let i = 0; i < data.length; i++) {
        const item = data[i]

        const productPLU = item.productPLU || {}
        const PLUCode = productPLU.PLUCode || ''

        const unit = productPLU.unit || {}
        const unitName = unit.name || ''
        const SKURatio = productPLU.SKURatio || ''

        const category = item.category || { id: 0, name: 'Unclassified', nameTranslation: { EN: 'Unclassified', TH: 'ไม่ระบุประเภท' } }
        const locale = this.$i18n.locale.toUpperCase()
        const typeName = (category.nameTranslation && category.nameTranslation[locale]) || category.name || 'Unclassified'

        detail.push({
          index: i + 1,
          date: item.date || '',
          PLUCode: PLUCode,
          name: productPLU.name || '',
          typeName: typeName,
          category: category,
          unit: unitName,
          SKURatio: SKURatio,
          totalQuantity: item.totalQuantity || 0,
          totalCost: util.convertCurrency(item.totalCost || 0),
          totalAmount: util.convertCurrency(item.totalAmount || 0),
        })
      }
      return detail
    },
  },
  created() {
    this.getStockOutReportByItem()
    this.getStockOutCategory()
  },
  methods: {
    ...util,
    getStockOutCategory() {
      const uid = `${localStorage.getItem('shopsUid')}`
      const shopObjectId = this.shopObjectId
      local
        .get('/api/v3.0/shop/stock/export/category', {
          params: { onlyDefault: true },
          headers: { shopObjectId: shopObjectId },
        })
        .then((res) => {
          if (res && res.data) {
            this.typeOptions = res.data.data || res.data || []
          }
        })
        .catch((error) => {
          console.error('Error fetching stock out category:', error)
        })
    },
    getCategoryName(category) {
      if (!category) return 'Unclassified'
      const locale = this.$i18n.locale.toUpperCase()
      // Try to find full data from typeOptions (has nameTranslation)
      const option = this.typeOptions.find(t => t.id === category.id)
      if (option && option.nameTranslation && option.nameTranslation[locale]) {
        return option.nameTranslation[locale]
      }
      // Fallback to category's own nameTranslation or name
      return (category.nameTranslation && category.nameTranslation[locale]) || category.name || 'Unclassified'
    },
    getStockOutReportByItem(page = 1) {
      this.loadingButton = false
      const shopObjectId = this.shopObjectId
      const startAt = moment(String(this.date.start)).format('YYYY-MM-DD')
      const endAt = moment(String(this.date.end)).format('YYYY-MM-DD')

      let params = {
        shopObjectId: shopObjectId,
        startAt: startAt,
        endAt: endAt,
        page: page,
        limit: this.meta_data.limit,
      }
      if (this.keyword !== '') {
        params.searchVal = this.keyword
      }
      if (this.selectedType !== '') {
        params.category = this.selectedType
      }

      this.loading = true

      axios
        .get('/api/v3.0/stockdocument/export/bycategory', {
          params,
          headers: { shopObjectId: shopObjectId },
        })
        .then((res) => {
          if (res && res.data) {
            const data = res.data
            this.dataByItem = data.data || data || []
            // Pagination
            const paginate = data.paginate || {}
            this.meta_data.items = paginate.items || 0
            this.meta_data.last_page = paginate.pageCount || 0
            this.meta_data.current_page = paginate.currentPage || 0
            this.meta_data.itemCount = paginate.itemCount || 0
            this.meta_data.limit = paginate.perPage || 50
          }

          this.loading = false
          this.loadingButton = true
        })
        .catch((error) => {
          console.log(error)
        })
    },
    exportStockOutReport() {
      const uid = `${localStorage.getItem('shopsUid')}`
      const shopObjectId = this.shopObjectId

      const startAt = moment(String(this.date.start)).format('YYYY-MM-DD')
      const endAt = moment(String(this.date.end)).format('YYYY-MM-DD')

      const params = {
        shopObjectId: shopObjectId,
        startAt: startAt,
        endAt: endAt,
      }
      if (this.keyword !== '') {
        params.searchVal = this.keyword
      }
      if (this.selectedType !== '') {
        params.category = this.selectedType
      }

      report({
        url: '/api/v3.0/stockdocument/export/bycategory/excel',
        params: params,
        method: 'GET',
        headers: { shopObjectId: shopObjectId },
        responseType: 'blob', // important
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'รายงานจ่ายสินค้าออกตามประเภท.xlsx') //or any other extension
          document.body.appendChild(link)
          link.click()
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
}
</script>
<style>
.btn-reset {
  box-shadow: 0 0 0 1px #e5e5e5;
}
.btn-reset:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.sort {
    background: rgba(0, 0, 0, 0.03);
    position: inherit;
    padding: 1px 1px;
    border: 1px solid;
    border-color: #d8dbe0;
    border-radius: 0.25rem;
}
</style>
